import { useCallback, useEffect, useState } from 'react';
import { apiUrl } from '@/config/api';

const useWalletTransactions = (token, { pageSize = 20, errorMessage } = {}) => {
  const [transactions, setTransactions] = useState([]);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [initialized, setInitialized] = useState(false);

  const loadPage = useCallback(
    async (nextOffset = 0) => {
      if (!token) {
        setTransactions([]);
        setTotal(0);
        setOffset(0);
        setLoading(false);
        setInitialized(false);
        return;
      }

      setLoading(true);
      setError('');

      try {
        const params = new URLSearchParams({ limit: pageSize, offset: nextOffset });
        const response = await fetch(apiUrl(`/api/me/balance-transactions?${params.toString()}`), {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          const data = await response.json().catch(() => ({}));
          throw new Error(data.error || errorMessage || 'Не удалось загрузить транзакции');
        }

        const data = await response.json();
        setTransactions(Array.isArray(data.transactions) ? data.transactions : []);
        setTotal(Number(data.total) || 0);
        setOffset(Number.isInteger(data.offset) ? data.offset : nextOffset);
      } catch (loadError) {
        setError(loadError.message);
        setTransactions([]);
        setTotal(0);
      } finally {
        setInitialized(true);
        setLoading(false);
      }
    },
    [token, pageSize, errorMessage],
  );

  const reload = useCallback(() => loadPage(offset), [loadPage, offset]);

  useEffect(() => {
    setTransactions([]);
    setTotal(0);
    setOffset(0);
    setInitialized(false);
    setError('');
  }, [token, pageSize]);

  return {
    transactions,
    total,
    offset,
    limit: pageSize,
    loading,
    error,
    loadPage,
    reload,
    initialized,
  };
};

export default useWalletTransactions;
